// extracted by mini-css-extract-plugin
export var discountConditionMoreWidget = "discount-condition-list-module--discount-condition-more-widget--2i-dI";
export var labelButton = "discount-condition-list-module--label-button--nBDFM";